module.exports = __webpack_public_path__ + "img/GGJLequipe.c408d87c.jpg";